/**
 * Language-neutral brand data and asset paths.
 * All copy lives in src/lib/i18n/{en,de}.js
 */

export const AGENCY = {
  name: 'Romilda Marketing Hub',
  shortName: 'Romilda',
  email: 'info@romildamarketinghub.com',
  website: 'www.romildamarketinghub.com',
  websiteUrl: 'https://www.romildamarketinghub.com',
  whatsappNumber: '+49 1577 8768136',
  whatsappRaw: '4915778768136',
  linkedin: 'https://www.linkedin.com/in/romilda-bahollari-7a6449217',
  instagram: 'https://www.instagram.com/romildamarketinghub',
  tiktok: 'https://www.tiktok.com/@__romilda',
  facebook: 'https://www.facebook.com/share/18x2N17B2k/',
};

/** Builds a wa.me deep link with a localised prefilled message. */
export const whatsappLink = (message) =>
  `https://wa.me/${AGENCY.whatsappRaw}${
    message ? `?text=${encodeURIComponent(message)}` : ''
  }`;

/** Studio credit shown in the footer. */
export const CREDIT = {
  label: 'cloudservice.hr',
  url: 'https://cloudservice.hr',
  instagram: 'https://www.instagram.com/cloudservice.hr',
};

export const IMAGES = {
  // Vector logo artwork lives in src/lib/logoPaths.js and is rendered inline
  // via <Logo /> so it inherits currentColor on any background.
  monogramSvg: '/rmh-monogram.svg',
  logoSvg: '/rmh-logo.svg',
  ogImage: '/og-image.jpg',
  // Editorial portraits of Romilda (black & white), self-hosted and optimised.
  heroPortrait: '/images/romilda-hero.jpg',
  heroPortraitWebp: '/images/romilda-hero.webp',
  aboutPortrait: '/images/romilda-portrait.jpg',
  aboutPortraitWebp: '/images/romilda-portrait.webp',
  editorialPortrait: '/images/romilda-editorial.jpg',
  editorialPortraitWebp: '/images/romilda-editorial.webp',
  authorityPortrait: '/images/romilda-authority.jpg',
  authorityPortraitWebp: '/images/romilda-authority.webp',
};

/** Nav entries reference i18n keys instead of hardcoded labels. */
export const NAV_LINKS = [
  { key: 'home', to: '/' },
  { key: 'services', to: '/services' },
  { key: 'about', to: '/about' },
  { key: 'contact', to: '/contact' },
];

export const CONSULTATION_PATH = '/contact#consultation-form';

export const SERVICE_SLUGS = [
  'social-media-management',
  'content-strategy-aesthetic',
  'visual-identity-branding',
  'digital-strategy',
];
